import { render } from "./user-info-onboard-modal.vue?vue&type=template&id=a1d8793e&ts=true"
import script from "./user-info-onboard-modal.vue?vue&type=script&lang=ts"
export * from "./user-info-onboard-modal.vue?vue&type=script&lang=ts"

import "./user-info-onboard-modal.vue?vue&type=style&index=0&id=a1d8793e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__